export const STEPS = {
  HOUR: "HOUR",
  MINUTE: "MINUTE",
  DAY: "DAY"
}